import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import { addDocumentNpwp } from "features/common/layouts/cartSlice";
import { useDispatch, useSelector } from "react-redux";
// import customInput from "../../assets/scss/ModalFakturPajak.module.scss"; // File sudah dihapus
import {
  sendDocumentNpwp,
  resetStatusNPWP,
} from "features/common/layouts/cartSlice";
import { notifyWarning, notifyError, notifySuccess } from "components/ToastMessage";

const ModalFakturPajak = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [sendFile, setSendFile] = useState("");
  const [formData, setFormData] = useState({
    npwp_no: "",
    npwp_company: "",
    npwp_address: "",
  });
  const { status_login } = useSelector((state) => state.auth);
  const { documentNpwp } = useSelector((state) => state.cart);

  const handleInputChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const handleFileChange = (event) => {
    const imageFile = event.target.files[0];
    setSendFile(imageFile);

    const reader = new FileReader();
    reader.onload = () => {
      setFormData({
        ...formData,
        fileData: reader.result,
      });
    };
    reader.readAsDataURL(imageFile);
  };

  const handlerFakturPajak = (event) => {
    event.preventDefault();

    if (!formData.npwp_no) {
      notifyWarning("Nomor NPWP Anda Belum Terisi!");
      return;
    }

    if (!formData.npwp_company) {
      notifyWarning("Nama NPWP Anda Belum Terisi!");
      return;
    }

    if (!formData.npwp_address) {
      notifyWarning("Alamat NPWP Anda Belum Terisi!");
      return;
    }

    if (!sendFile) {
      notifyWarning("Foto NPWP Anda Belum Terisi!");
      return;
    }

    if (sendFile.size > 2 * 1024 * 1024) {
      notifyError(
        "Harap periksa ukuran file Anda. Ukuran maksimal yang diperbolehkan adalah 2MB."
      );
      return;
    }

    if (
      sendFile.type !== "image/jpg" &&
      sendFile.type !== "image/png" &&
      sendFile.type !== "image/jpeg"
    ) {
      notifyError(
        "Maaf, hanya file dengan ekstensi PNG, JPG, dan JPEG yang diperbolehkan."
      );
      return;
    }

    setButtonDisable(true);
    setLoading(true);

    if (formData) {
      if (status_login) {
        dispatch(sendDocumentNpwp(sendFile));
      } else {
        notifyError("Anda belum login!");
      }
    }
  };

  useEffect(() => {
    if (documentNpwp.status === "fulfilled") {
      setButtonDisable(false);
      setLoading(false);
      dispatch(addDocumentNpwp({ formData, label: "Sudah Lengkap" }));
      notifySuccess("Kelengkapan NPWP Berhasil di Upload");
      dispatch(resetStatusNPWP("idle"));
      props.onHide();
    } else if (documentNpwp.status === "error") {
      setButtonDisable(false);
      setLoading(false);
      notifyError(`${documentNpwp.error}`);
      dispatch(resetStatusNPWP("idle"));
    } else if (documentNpwp.status === "idle") {
      setButtonDisable(false);
      setLoading(false);
    }
  }, [dispatch, documentNpwp.status, props, documentNpwp.error, formData]);

  return (
    <>
      <Modal show={props.show} onHide={props.onHide} backdrop="static" centered>
        <Modal.Header closeButton>
          <Modal.Title>Faktur Pajak</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handlerFakturPajak}>
            <div className="form">
              <div className="mb-3">
                <Form.Group controlId="npwp_no" className="mb-3">
                  <Form.Label>Nomor NPWP</Form.Label>
                  <Form.Control
                    type="text"
                    name="npwp_no"
                    placeholder="Masukkan No NPWP Anda"
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </div>
              <div className="mb-3">
                <Form.Group controlId="npwp_company" className="mb-3">
                  <Form.Label>Nama NPWP</Form.Label>
                  <Form.Control
                    type="text"
                    name="npwp_company"
                    placeholder="Masukkan Nama NPWP Anda"
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </div>
              <div className="mb-3">
                <Form.Group controlId="npwp_address" className="mb-3">
                  <Form.Label>Alamat sesuai NPWP</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="npwp_address"
                    placeholder="Masukkan Alamat NPWP Anda"
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </div>
              <div className="mb-3">
                <Form.Group controlId="foto_npwp" className="mb-3">
                  <Form.Label>Foto NPWP</Form.Label>
                  <div className="d-flex">
                    <Form.Control
                      type="file"
                      className="form-control"
                      name="foto_npwp"
                      placeholder="Masukkan Foto NPWP Anda"
                      onChange={handleFileChange}
                    />
                    <Form.Label className="btn btn-outline-secondary">
                      Pilih Gambar
                    </Form.Label>
                  </div>
                  <p
                    className="text-secondary mt-2"
                    style={{ fontSize: "12px" }}
                  >
                    <i>
                      *File: Maks. 2MB, tipe yang diperbolehkan: PNG, JPG, JPEG.
                    </i>
                  </p>
                </Form.Group>
              </div>
              <p className="mt-2">
                Faktur Pajak akan dibuatkan 3-7 Hari Kerja setelah Invoice Paid.
              </p>
            </div>
            <div className="row mt-5">
              <button
                className="btn btn-modal-login"
                disabled={buttonDisable}
                type="submit"
              >
                {loading ? <Spinner animation="border" size="sm" /> : "Simpan"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalFakturPajak;
